/* Colorway swatches - swap the card in place instead of navigating.
   Progressive enhancement: without JS the swatches remain plain links.

   Active state differs by style:
     color - an outline box around the active chip
     image - the inactive thumbnails fade back, so nothing boxes in the photo

   The price is deliberately left alone. Shopify's money filter can return
   markup (translation apps wrap it in a span), so writing it back as text
   would print the tags literally. */
(function () {
  if (window.__colorwaySwatchesInit) return;
  window.__colorwaySwatchesInit = true;

  function markActive(swatches, active) {
    for (var i = 0; i < swatches.length; i++) {
      var s = swatches[i];
      var isImage = s.getAttribute('data-cw-style') === 'image';
      var on = s === active;
      if (isImage) {
        s.style.opacity = on ? '1' : '0.5';
        s.style.borderColor = 'transparent';
      } else {
        s.style.borderColor = on ? 'currentColor' : 'transparent';
        s.style.opacity = '1';
      }
      if (on) {
        s.setAttribute('aria-current', 'true');
      } else {
        s.removeAttribute('aria-current');
      }
    }
  }

  function swap(link) {
    var card = link.closest('.product-tile__container');
    if (!card) return;

    var mediaLink = card.querySelector('a.product-tile__featured-media');
    var img = mediaLink ? mediaLink.querySelector('img') : null;
    var newSrc = link.getAttribute('data-cw-img');
    if (img && newSrc) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', newSrc);
    }

    /* the hover image belongs to the previous colorway - retire it */
    if (mediaLink) {
      var hoverWrap = mediaLink.querySelector('.pointer-events-none.absolute.inset-0');
      if (hoverWrap) hoverWrap.style.display = 'none';
    }

    var url = link.getAttribute('data-cw-url');
    if (url) {
      var anchors = card.querySelectorAll('a[href]');
      for (var i = 0; i < anchors.length; i++) {
        if (anchors[i].closest('.colorway-swatches')) continue;
        anchors[i].setAttribute('href', url);
      }
    }

    var newTitle = link.getAttribute('data-cw-title');
    var titleEl = card.querySelector('h3');
    if (titleEl && newTitle) titleEl.textContent = newTitle;

    markActive(card.querySelectorAll('.colorway-swatches a'), link);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('.colorway-swatches a[data-cw-url]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    swap(link);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('.colorway-swatches a[data-cw-url]');
    if (!link) return;
    e.preventDefault();
    swap(link);
  }, true);
})();
